// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpPackPitch-cls1_Wu-","cls2":"LoswpPackPitch-cls2_j5_ LoswpPackPitch-cls1_Wu-"};